import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { ExtendedStatisticsItemModel } from '../../../models/extended-statistics-item.model';
import { StatisticsResource } from '../../../services/resources/statistics.resource';

@Component({
    selector: 'sl-shareholders-domicile',
    templateUrl: './shareholders-domicile.component.html',
    styleUrls: ['./shareholders-domicile.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ShareholdersDomicileComponent implements OnInit {
    data: ExtendedStatisticsItemModel[] = [];
    total = 0;
    lastPercentage = 0;

    private readonly statisticsResource = inject(StatisticsResource);

    ngOnInit(): void {
        this.statisticsResource.getDomicile().subscribe(resp => {
            this.total = resp.value.reduce((currentTotal, item) => (currentTotal += item.value), 0);
            const newData = [...resp.value];

            newData.pop();

            const usedPercentage = newData.reduce(
                (currentPercentage, item) => (currentPercentage += +((item.value / this.total) * 100).toFixed(2)),
                0
            );
            const lastPercentage = +(100 - usedPercentage).toFixed(2);

            for (let i = 0; i < resp.value.length; i++) {
                const item = resp.value[i];
                const pct = i === resp.value.length - 1 ? lastPercentage : +((item.value / this.total) * 100).toFixed(2);

                this.data.push(
                    new ExtendedStatisticsItemModel({
                        ...item,
                        percentage: pct
                    })
                );
            }
        });
    }
}
